import { get, post, put, listData } from "../httpmethods";
import { URL_API } from "../config";


export const ServiceAPI = {
    createServices: async (body) => {
        return await post(`${URL_API}/services`, body);
    },
    getServices: async (data) => {
        return await listData(`${URL_API}/services`, data);
    },
    getServiceByGuid: async (guid) => {
        return await get(`${URL_API}/services/${guid}`);
    },
    cancelService: async (guid) => {
        return await post(`${URL_API}/services/${guid}/cancel`);
    },
    finishService: async (guid) => {
        return await post (`${URL_API}/services/${guid}/finish`);
    },
    startService: async (guid) => {
        return await post(`${URL_API}/services/${guid}/start`);
    },
}
